export const RINGBA_TAG = { tag: "", value: null, type: "", id: "" };

export const RINGBA_TAG_VALUES = [
  { text: "true", value: true },
  { text: "false", value: false },
  { text: "53", value: 53 },
  { text: "65", value: 65 },
  { text: "86", value: 86 },
];

export const AUDIO_FILE = {
  fileID: "",
  fileURL: "",
  fileName: "",
};

export const MESSAGE = {
  messageType: "message",
  content: "",
  backgroundColor: "",
  delay: 2000,
  human: false,
  cssClass: "",
  hasRingbaScript: false,
  ringbaScript: "",
  children: [],
  audio: { ...AUDIO_FILE },
};

export const DEFAULT_QUESTION = {
  messageType: "defaultQuestion",
  content: "",
  delay: 2000,
  children: [],
  defaultQuestionType: "",
};

export const ACTION = {
  messageType: "action",
  delay: 2000,
  cssClass: "",
  children: [],
};

export const ACTION_ITEM = {
  messageType: "actionItem",
  text: "",
  backgroundColor: "",
  value: "",
  hasRingbaScript: false,
  ringbaScript: "",
  ringbaTags: [],
  children: [],
  audio: { ...AUDIO_FILE },
};

export const INPUT_QUESTION = {
  messageType: "inputQuestion",
  delay: 2000,
  content: "",
  children: [],
  inputQuestionType: "",
  displayUserAnswer: false,
};

export const DECISION = {
  messageType: "decision",
  children: [],
  ringbaTags: [],
  greaterThan: null,
  greaterThanOrEqual: null,
  lessThan: null,
  lessThanOrEqual: null,
};
